'use strict';

var novicell = novicell || {}; // eslint-disable-line

novicell.formValidation = novicell.formValidation || new function () {
    this.init = function () {
       let form = document.getElementById('register-form');
       if(!form) return;
       let checkboxInput = form.querySelector('.ef-checkbox__input');
       let errorMessage = form.querySelector(".checkbox-error");
       
       form.addEventListener("submit", (e) => {
           e.preventDefault();
           if(checkboxInput.value === "true")
           {
               form.submit();
            }
           else if(checkboxInput.value === "false"){
               if (errorMessage.classList.contains("checkbox-error--hidden")){
                errorMessage.classList.toggle("checkbox-error--hidden");
               }
           }
       });

    };
}();
